import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Offcanvas, Nav, Image } from "react-bootstrap";
import "./index.css";
import {
  MdDashboard,
  MdPeople,
  MdInventory,
  MdBusiness,
  MdShoppingCart,
} from "react-icons/md";
import CloseBtn from "../modals/CloseBtn";

const drawerWidth = 240;

const menuItems = [
  { text: "Dashboard", icon: MdDashboard, path: "/" },
  { text: "Partners", icon: MdBusiness, path: "/partners" },
  { text: "Orders", icon: MdShoppingCart, path: "/orders" },
  { text: "Users", icon: MdPeople, path: "/users" },
  { text: "Sleeve Module", icon: MdInventory, path: "/sleeves" },
  { text: "Couriers", icon: MdInventory, path: "/couriers" },
];

const Sidebar = ({ mobileOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  const handleDrawerToggle = () => onClose?.();

  const handleNavigation = (path) => {
    navigate(path);
    if (isMobile) {
      onClose?.();
    }
  };

  const drawer = (
    <div>
      {/* <div className="p-3 text-center fw-bold">Refresh</div> */}
      <figure className="m-0 d-none d-md-flex align-items-center justify-content-center p-3">
        <Image
          alt="logo"
          src="./logo.png"
          className="img-fluid"
          style={{ maxHeight: "42px" }}
        />
      </figure>

      <Nav className="flex-column gap-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Nav.Link
              key={item.text}
              onClick={() => handleNavigation(item.path)}
              active={isActive}
              className={`d-flex align-items-center gap-2 px-2 py-2`}
            >
              <Icon size={20} />
              <span>{item.text}</span>
            </Nav.Link>
          );
        })}
      </Nav>
    </div>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="d-none d-md-block  sidebar">
        <div className="drawer-cover">{drawer}</div>
      </div>

      {/* Mobile Sidebar */}
      <Offcanvas
        show={!!mobileOpen}
        onHide={handleDrawerToggle}
        placement="start"
        style={{ width: drawerWidth }}
      >
        <Offcanvas.Header className="">
          <CloseBtn onClick={handleDrawerToggle} color="#bf352b" />
          <Offcanvas.Title>
            <figure className="m-0 align-items-center justify-content-center p-3">
              <Image
                alt="logo"
                src="./logo.png"
                className="img-fluid"
                style={{ maxHeight: "42px" }}
              />
            </figure>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">{drawer}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Sidebar;
